module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO7_03 (10).c3a0190.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO7_03 (10).mp4
// module id = 785
// module chunks = 1